import { Component, EventEmitter, Output } from "@angular/core";

export interface Will4HowItWorksStep {
	number: number;
	iconSrc: string;
	iconAlt: string;
	title: string;
	description: string;
}

@Component({
	selector: "app-will4-how-it-works-section",
	templateUrl: "./will4-how-it-works-section.component.html",
	styleUrls: ["./will4-how-it-works-section.component.scss"],
})
export class Will4HowItWorksSectionComponent {
	@Output() ctaClick = new EventEmitter<void>();

	readonly steps: Will4HowItWorksStep[] = [
		{
			number: 1,
			iconSrc: "../../../assets/images/funeral-how-step-2.svg",
			iconAlt: "Organize Important Details",
			title: "Organize Important Details",
			description:
				"<b>Gather the information you'll need before you begin.</b> Collect important contacts, funeral home and cemetery information, parish details, and other logistics to make completing your Funeral Plan simple.",
		},
		{
			number: 2,
			iconSrc: "../../../assets/images/funeral-how-step-1.svg",
			iconAlt: "Create Your Free Funeral Plan",
			title: "Create Your Free Funeral Plan",
			description:
				"<b>Make your wishes known.</b> Answer guided questions to record your Funeral Mass preferences, readings, hymns, burial wishes, prayers, and other instructions.",
		},
		{
			number: 3,
			iconSrc: "../../../assets/images/funeral-how-step-3.svg",
			iconAlt: "Download, Share, and Update Anytime",
			title: "Download, Share, and Update Anytime",
			description:
				"<b>Keep your plan accessible.</b> Download the completed Funeral Plan, share it with loved ones and your parish, and update it anytime as your wishes or circumstances change.",
		},
	];

	onCtaClick(): void {
		this.ctaClick.emit();
	}
}
